// extracted by mini-css-extract-plugin
export default {"heading":"JoinBrand_heading__I+t8l","icon":"JoinBrand_icon__cR-k9","logoContainer":"JoinBrand_logoContainer__4JnWE","buttonText":"JoinBrand_buttonText__+3aJu"};